import { apiFetch } from "./api";
import { BASE_URL as u } from "../commonUrls";

const BASE_URL = `${u}/planner`;

export const getCalendarEvents = async (start, end) => {
  const res = await apiFetch(`${BASE_URL}/calendar?start=${start}&end=${end}`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
};

const normalizeTime = (value) => {
  if (!value) return null;
  return value.length === 5 ? `${value}:00` : value;
};

export const updatePlannerDate = async (id, date, startTime, endTime, allDay) => {
  const payloadDate = date ? date.slice(0, 10) : date;
  const res = await apiFetch(`${BASE_URL}/${id}/date`, {
    method: "PATCH",
    body: JSON.stringify({
      date: payloadDate,
      startTime: normalizeTime(startTime),
      endTime: normalizeTime(endTime),
      allDay,
    }),
  });
  return res.json();
};

export const getAttendees = async () => {
  const res = await apiFetch(`${u}/user/attendees`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
};
